export const PREFILL_PHONE_IS_INELIGIBLE = 'PREFILL_PHONE_IS_INELIGIBLE';

export const prefillPhoneIsIneligible = payload => dispatch =>
  dispatch({
    type: PREFILL_PHONE_IS_INELIGIBLE,
    payload,
  });
